import { createFileRoute } from '@tanstack/react-router';
import Docs from 'containers/Docs';

export const Route = createFileRoute('/_authenticated/instructions')({
  component: Docs,
});
